import { ref, computed } from 'vue';

import { useI18n } from 'vue-i18n'

export function useMessages(addKey, editKey) {
	// хранит заголовок формы и надписи на кнопках для добавления и обновления базовой станции
	const { t } = useI18n();
	const currentKey = ref(addKey);
	const label = ref(null);
	const messages = computed(() => ({
		formTitle: label.value ? t(currentKey.value + '.formTitleWithLabel', { label: label.value }) : t(currentKey.value + '.formTitle'),
		submitButtonLabel: t(currentKey.value + '.submitButtonLabel'),
		submitAndCloseButtonLabel: t(currentKey.value + '.submitAndCloseButtonLabel'),
		successMessage: t(currentKey.value + '.messages.success'),
	}));
	const setBaseStationLabel = newLabel => {
		label.value = newLabel;
	}
	const setEditModeMessages = () => {
		currentKey.value = editKey;
	};
	return {
		messages,
		setBaseStationLabel,
		setEditModeMessages,
	}
}
